import { Spin } from 'antd'
import { ComponentProps } from 'react'
import { Bar } from 'react-chartjs-2'
import { useInflowProportionAgeGroupTrendValues } from '../../../../api/benchmarking'
import BenchmarkingContentRow from '../../components/BenchmarkingContentRow'
import { getFontSize } from '../../util/fontSize'
import { getColorByIndex } from '../../util/colors'
import { BenchmarkingLegend } from '../../components/BenchmarkingLegend'
import { BORDER_WIDTH } from '../../util/constants'
import { baseGraphOptions } from '../../util/baseGraphOptions'
import { EmptySelector } from '../../components/EmptySelector'
import { NO_COMPARISON, STATDB_NAME } from '../../util/names'

export const InflowProportionAgeGroupTrend = ({ text }: { text: React.ReactNode }) => {
  const { data, isLoading } = useInflowProportionAgeGroupTrendValues()

  if (isLoading) {
    return <BenchmarkingContentRow graph={<Spin size="large" />} text={text} />
  }

  if (!data) {
    return <></>
  }

  const graphOptions: ComponentProps<typeof Bar>['options'] = {
    ...baseGraphOptions,
    responsive: true,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        callbacks: {
          label: (context) => {
            return `${context.dataset.label}: ${Math.round(context.parsed.y)}%`
          },
        },
      },
    },
    scales: {
      x: {
        stacked: true,
        min: 0,
        max: 100,
        ticks: {
          font: {
            size: getFontSize('md'),
          },
        },
      },
      y: {
        stacked: true,
        min: 0,
        max: 100,
        ticks: {
          font: {
            size: getFontSize('md'),
          },
          callback: (value) => `${value}%`,
        },
      },
    },
  }

  const graphData = {
    labels: data?.[0]?.values?.map((item) => item.year) ?? [],
    datasets: data.map((item, index) => ({
      fill: false,
      label: item.ageRange,
      data: item.values?.map((item) => item.value),
      borderColor: getColorByIndex(index).border,
      backgroundColor: getColorByIndex(index).fill,
      borderWidth: BORDER_WIDTH,
    })),
  }
  const legend = <BenchmarkingLegend items={data.map((value, index) => ({ fillColor: getColorByIndex(index).fill, borderColor: getColorByIndex(index).border, text: value.ageRange }))} />
  const title = 'Andel nya beslut per åldersgrupp, trend'
  const graph: React.ReactNode = <Bar options={graphOptions} data={graphData} />

  const dataSourceSelector = <EmptySelector value={STATDB_NAME} />
  const comparisonSelector = <EmptySelector value={NO_COMPARISON} />
  return <BenchmarkingContentRow graph={graph} text={text} title={title} legend={legend} dataSourceSelector={dataSourceSelector} comparisonSelector={comparisonSelector} />
}
